module.exports = __webpack_public_path__ + "solution-build/img/newsItem@2.dd74763e.jpg";